//=====================================================
//　診療時間
//=====================================================

import { useContext } from 'react';
import { CtxClinicInfo } from '../../utils/Contexts';

export function HeaderConsulHours(){

    const cci = useContext(CtxClinicInfo);

    if (cci.data.consultationHoursImage){
        //診療時間画像表示
        return (
            <div className="header-dental-hours-img">
                <img src={cci.data.consultationHoursImage} alt="診療時間表"/>
            </div>
        )
    } else {
        //　診療時間、または休診日が設定されていれば表示
        if( cci.data.consultationHours || cci.data.closedDays ){
            //診療時間テキスト表示
            return (
                <div className="header-dental-hours-text">
                    <dl className="header-dental-hours-info_list text-multiline">
                        {cci.data.consultationHours &&
                            <>
                                <dt>診療時間</dt>
                                <dd>{cci.data.consultationHours}</dd>
                            </>
                        }
                        {cci.data.closedDays &&
                            <>
                                <dt>休診日</dt>
                                <dd>{cci.data.closedDays}</dd>
                            </>
                        }
                    </dl>
                </div>
            )
        }else{
            return null;
        }
    }
}